/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Pencil = createReactComponent("pencil", "Pencil", [["path", { "d": "M8.8 20.199A2.733 2.733 0 0 1 6.869 21H3v-3.844c0-.724.288-1.419.8-1.931m5 4.974-5-4.974m5 4.974 9.974-9.978M3.8 15.225l9.984-9.995m0 0 1.426-1.428a2.733 2.733 0 0 1 3.867-.001l1.126 1.127a2.733 2.733 0 0 1 0 3.865l-1.428 1.428M13.783 5.23l4.991 4.991", "key": "svg-0" }]]);

export { Pencil as default };
//# sourceMappingURL=Pencil.js.map
